import React from 'react';
import Chip from '@mui/material/Chip';
import { INTERN_STATUSES, BOOKING_STATUSES, ASSESSMENT_STATUSES, VIDEO_STATUSES } from '../../utils/constants';

const STATUS_MAPS = {
  intern: INTERN_STATUSES,
  booking: BOOKING_STATUSES,
  assessment: ASSESSMENT_STATUSES,
  videoStatus: VIDEO_STATUSES,
};

export default function StatusChip({ status, type = 'intern', size = 'small' }) {
  const map = STATUS_MAPS[type] || {};
  const config = map[status];
  const label = config?.label || status?.replace(/_/g, ' ') || 'Unknown';
  const color = config?.color || '#6b7280';

  return (
    <Chip
      label={label}
      size={size}
      sx={{
        backgroundColor: `${color}18`,
        color: color,
        fontWeight: 600,
        borderColor: `${color}40`,
        border: '1px solid',
      }}
    />
  );
}
